import { render } from "./DeliveryConfirmation.vue?vue&type=template&id=cd1fcbce"
import script from "./DeliveryConfirmation.vue?vue&type=script&lang=js"
export * from "./DeliveryConfirmation.vue?vue&type=script&lang=js"

import "./DeliveryConfirmation.vue?vue&type=style&index=0&id=cd1fcbce&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__